export class RegisterDto {
  countryCode: string;
  phone: string;
  name: string;
  idi: number;
  tableCartId: number;
  constructor(countryCode: string, phone: string, name: string, idi: number, tableCartId: number) {
    this.countryCode = countryCode;
    this.phone = phone;
    this.name = name;
    this.idi = idi;
    this.tableCartId = tableCartId;
  }
}